module.exports = __webpack_public_path__ + "img/3.fd8c9121.png";